
CountryService.$inject = ['$http', 'i18nFilter'];

export function CountryService($http, i18nFilter) {

  return {

    getCountries: function () {
      return $http.get('/365FarmNet/rest/syscountry', {cache: true});
    },

    sortCountries: function (countries) {
      return _(countries).map(function (country) {
        return {
          isoCode: country.isoCode,
          shopCountry: country.shopCountry,
          translation: i18nFilter(
            'enums.CountryCodeEnum.' + country.isoCode,
            country.isoCode
          ),
          orderKey: i18nFilter(
            'enums.CountryCodeEnum.' + country.isoCode,
            country.isoCode
          ).replace('Ö', 'Oe') // Workaround until we support ordering with collation of selected country
        }
      })
    }
  }
}
